// extracted by mini-css-extract-plugin
module.exports = {"matchedPhrase":"MatchedPhraseText-module__matchedPhrase___2yrjV"};